import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { INITIAL_STATE } from '../constants/config';
import thunkMiddleware from 'redux-thunk'; // Import Redux Thunk middleware

// Reducers
import authReducer from './auth/AuthSlice';
import customerReducer from './customer/CustomerSlice';
import commonReducer from './common/CommonSlice';
import layoutReducer from './layout/LayoutSlice';
import serviceLevelReducer from './setup/serviceLevel/ServiceLevelSlice';
import priceSheetReducer from './setup/priceBook/priceSheet/PriceSheetSlice';
import erpProductSearchReducer from './setup/erpSerachProduct/ErpProductSearchSlice';
import warrantyReducer from './setup/warranty/WarrantySlice';
import contractsReducer from './entitlement/contracts/ContractsSlice';
import eTrackSettingsReducer from './setup/eTrackSettings/ETrackSettingsSlice';
import billClassReducer from './setup/priceBook/billClass/BillClassSlice';
import priceClassReducer from './setup/priceBook/priceClass/PriceClassSlice';
import oosBillSetsReducer from './setup/oosBillSets/oosBillSetsSlice';
import salesMappingReducer from './entitlement/contracts/salesMapping/SalesMappingSlice';
import warrantyPeriodReducer from './entitlement/contracts/warrantyExtendedPeriod/WarrantyExtendedPeriodSlice';
import customersSearchReducer from './entitlement/customers/CustomersSearchSlice';
import addNewContractReducer from './entitlement/contracts/addContract/AddContractSlice';
import erpSalesOrderReducer from './entitlement/erpSalesOrder/ErpSalesOrderSlice';
import entitlementSummaryReducer from './entitlement/site/entitlementSummary/EntitlementSummarySlice';
import NotesReducer from './entitlement/site/notes/NotesSlice';
import contractNotesReducer from './entitlement/contracts/notes/NotesSlice';
import siteActivityReducer from './entitlement/siteActivity/SiteActivitySlice';
import entitlementsReducer from './entitlement/entitlements/EntitlementsSlice';
import entitlementHistorySlice from './entitlement/entitlementHistory/EntitlementHistorySlice';
import siteSliceReducer from './entitlement/site/SiteSlice';
import entitlementsShippingInfoReducer from './entitlement/entitlements/entitlementsShippingInfo/EntitlementsShippingInfoSlice';
import entitlementDetailsReducer from './entitlement/site/entitlementDetails/EntitlementDetailsSlice';
import outOfScopeCasesReducer from './entitlement/outOfScopeCases/OutOfScopeCasesSlice';
import batchUpdateReducer from './entitlement/outOfScopeCases/BatchUpdate.Slice';
import SearchAndRetrieveSalesOrderSlice from './entitlement/searchAndRetrieveSalesOrder/SearchAndRetrieveSalesOrderSlice';
import contractHistorySlice from './entitlement/contracts/contractHistory/ContractHistorySlice';
import entitlementsSiteActivityReducer from './entitlement/entitlements/entitlementsDetails/EntitlementsSiteActivitySlice';
import siteActivityDetailReducer from './entitlement/site/siteActivityDetail/SiteActivityDetailSlice';
import entitlementContractHistory from './entitlement/entitlements/entitlementContractHistory/EntitlementContractHistorySlice';
import erpSalesOrderItemsReducer from './entitlement/erpSalesOrderItems/ErpSalesOrderItemsSlice';
import warrantyInfoReducer from './entitlement/entitlements/warrantyInfo/WarrantyInfoSlice';
import eTrackExistingQuoteReducer from './eTrack/existingQuote/existingQuote';
import eTrackQuoteApprovalReducer from './eTrack/quoteApproval/quoteApproval';
import billingToolSliceReducer from './billing/billingTool/BillingToolSlice';
import cpiSetupSliceReducer from './billing/cpiSetup/CpiSetupSlice';
import AdminScreenRoleReducer from './userSetup/adminScreenRole/AdminScreenRoleSlice';
import eTrackQuoteReducer from './eTrack/EtrackSlice';
import contractOutOfScopeReducer from './entitlement/contracts/contractOutOfScope/ContractOutOfScopeSlice';
import entilementsBillingActivityReducer from './entitlement/entitlements/entitlementBillingActivity/EntilementBillingActivitySlice';
import copyConractReducer from './entitlement/contracts/copyContract/CopyContractSlice';
import siteHistoryReducer from './entitlement/site/siteHistory/SiteHistorySlice';
import relatedContractsReducer from './entitlement/contracts/relatedContracts/RelatedContractsSlice';
import auditTrailReducer from './entitlement/contracts/auditTrail/AuditTrailSlice';
import eTrackUserMCNMappingReducer from './userSetup/eTrackUserMCNMapping/ETrackUserMCNMappingSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  customer: customerReducer,
  common: commonReducer,
  layout: layoutReducer,
  seriveLevel: serviceLevelReducer,
  erpProductSearch: erpProductSearchReducer,
  warranty: warrantyReducer,
  contracts: contractsReducer,
  priceSheet: priceSheetReducer,
  eTrackSettings: eTrackSettingsReducer,
  priceClass: priceClassReducer,
  billClass: billClassReducer,
  oosBillSets: oosBillSetsReducer,
  salesMapping: salesMappingReducer,
  warrantyPeriod: warrantyPeriodReducer,
  customers: customersSearchReducer,
  addNewContract: addNewContractReducer,
  erpSalesOrder: erpSalesOrderReducer,
  contractNotes: contractNotesReducer,
  siteActivity: siteActivityReducer,
  entitlements: entitlementsReducer,
  entitlementHistory: entitlementHistorySlice,
  site: siteSliceReducer,
  entitlementSummary: entitlementSummaryReducer,
  notes: NotesReducer,
  entitlementsShippingInfo: entitlementsShippingInfoReducer,
  entitlementDetails: entitlementDetailsReducer,
  outOfScopeCases: outOfScopeCasesReducer,
  batchUpdate: batchUpdateReducer,
  erpSearchAndRetrieveSalesOrder: SearchAndRetrieveSalesOrderSlice,
  contractHistory: contractHistorySlice,
  entitlementsSiteActivity: entitlementsSiteActivityReducer,
  siteActivityDetail: siteActivityDetailReducer,
  entitlementContractHistory: entitlementContractHistory,
  erpSalesOrderItems: erpSalesOrderItemsReducer,
  warrantyInfo: warrantyInfoReducer,
  eTrackExistingQuote: eTrackExistingQuoteReducer,
  eTrackQuoteApproval: eTrackQuoteApprovalReducer,
  billingTool: billingToolSliceReducer,
  cpiSetup: cpiSetupSliceReducer,
  AdminScreenRole: AdminScreenRoleReducer,
  eTrackQuote: eTrackQuoteReducer,
  contractOutOfScope: contractOutOfScopeReducer,
  entitlementBillingActivity: entilementsBillingActivityReducer,
  copyContract: copyConractReducer,
  siteHistory: siteHistoryReducer,
  relatedContracts: relatedContractsReducer,
  auditTrail: auditTrailReducer,
  ETrackUserMCNMapping: eTrackUserMCNMappingReducer,
});

const store = configureStore({
  reducer: rootReducer,
  INITIAL_STATE,
  middleware: [thunkMiddleware], // Add Redux Thunk middleware
});

export default store;
